import { get, ref } from "firebase/database";
import * as actionType from "../../context/actions";
import { database } from "../../Utils/firebase";
import GetAssignerUserCustomerData from "../Firebase/AssignerUser/Customers/GetAssignerUserCustomerDataInFirebase";
import { Currency } from "lucide-react";

const GetCustomersData = async (state, dispatch, sharedBusinesses = null) => {
  try {
    const customerRef = ref(database, `invoiceGenerator/users/${state?.USERID}/customers`);
    const customersnapshot = await get(customerRef);
    const data = customersnapshot.val() || {};

    const customerMap = new Map();

    Object.entries(data).forEach(([id, info]) => {
      if (!info || !info.companyId || !info.customer) return;

      const key = `${info.companyId}-${info.customer}`;
      const amount = parseFloat(info.totalAmount) || 0;
      const totalPaid = parseFloat(info.totalPaid) || 0;

      // ✅ fix creation date parsing
      const rawDate = parseInt(info.creationDate || info.createdAt || Date.now());
      const creationDate =
        rawDate.toString().length > 10 ? new Date(rawDate) : new Date(rawDate * 1000);

      // ✅ use invoices array (fallback to empty array)
      const invoices = Array.isArray(info.invoices)
        ? info.invoices
        : info.invoiceId
          ? [info.invoiceId]
          : [];

      const ledger = Array.isArray(info.paymentsReceived)
        ? info.paymentsReceived
        : [];

      customerMap.set(key, {
        customer: info.customer,
        companyId: info.companyId,
        dialCode: info.dialCode || info.dial_code,
        phone: info.phone,
        email: info.email,
        customerGSTNo: info.customerGSTNo || null,
        address: info.address || null,
        invoices,
        totalAmount: amount,
        date: info.creationDate || info.createdAt,
        latestDate: creationDate,
        customerId: info.customerId || "",
        totalPaid: totalPaid || 0,
        uniqueId: id,
        paymentsReceived: ledger,
        createdBy: info.createdBy,
        createdById: state?.USERID || null,
        currency: info.currency || null,
      });
    });

    const uniqueCustomers = Array.from(customerMap.values()).map((item, index) => {
      const { latestDate, ...rest } = item;
      return {
        srNo: index + 1,
        ...rest,
        isShared: false
      };
    });

    let finalCustomers = uniqueCustomers;

    const businessesToUse = sharedBusinesses || state?.ASSIGNERUSERBUSINESSES || [];
    if (businessesToUse.length) {
      const sharedCustomers = await GetAssignerUserCustomerData(state, dispatch, businessesToUse);
      finalCustomers = [...finalCustomers, ...sharedCustomers];
    }

    // Fix sequential numbering after appending
    finalCustomers = finalCustomers.map((item, index) => ({
      ...item,
      srNo: index + 1
    }));

    dispatch({ type: actionType.CUSTOMERS, payload: finalCustomers });

    return finalCustomers;
  } catch (error) {
    console.error("Error fetching customer data:", error);
    return null;
  }
};

export default GetCustomersData;
